import styled from '@emotion/styled';
import { RaceSummaryCaption } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/RaceSummary.style';
import { withConfig } from 'src/withConfig';

export const EWInformation = withConfig(theme => styled('span', { label: 'EWInformation' })`
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.xMedium};
    line-height: 1.2;
    padding: 8px;
    text-align: right;
`);

export const RaceCaption = styled(RaceSummaryCaption, { label: 'RaceCaption' })`
    height: 32px;
`;

export const RunnerCaption = withConfig(theme => styled('div', { label: 'RunnerCaption' })`
    align-items: center;
    display: flex;
    flex: 1 1 0%;
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.xMedium};
    justify-content: flex-start;
    padding-left: 16px;
`);
